// TODO use https://www.robinwieruch.de/react-router-private-routes/
import { Modal } from "antd";
import React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { config } from "./config.js";
import { clubHasFinance, clubHasFlight } from "./featureMatrix.jsx";
import { $t } from "./i18n.js";
import { AanmeldLijstPagina } from "./pages/administratie/aanmeldLijst/aanmeldLijst.jsx";
import { PrintAanmeldLijstPagina } from "./pages/administratie/aanmeldLijst/aanmeldLijstPrint.jsx";
import { DagOverzichtPagina } from "./pages/administratie/dagOverzicht/dagOverzicht.jsx";
import { DagVerslagPagina } from "./pages/administratie/dagverslag/dagVerslag.jsx";
import { RoostersPagina } from "./pages/administratie/roosters/roosters.jsx";
import { SleepAdministratiePagina } from "./pages/administratie/sleep/sleep.jsx";
import { StartAdministratiePagina } from "./pages/administratie/start/start.jsx";
import { DagtotaalPagina } from "./pages/administratie/totaal/totaal.jsx";
import { Dashboard } from "./pages/dashboard/Dashboard.jsx";
import { DocumentShortcutPage } from "./pages/documents/documentShortcut.jsx";
import { DocumentsPagina } from "./pages/documents/documents.jsx";
import { EmailPage } from "./pages/email/EmailPage.jsx";
import { FindingDetailPage } from "./pages/findings/FindingDetailPage.jsx";
import { FindingsPage } from "./pages/findings/FindingsPage.jsx";
import { LedenLijstOverzichtPagina } from "./pages/ledenlijst/LedenLijstOverzicht.jsx";
import { DTOOverzicht } from "./pages/ledenlijst/DTOOverzicht.jsx";
import { ActivateEmailPage } from "./pages/login/activate_email.jsx";
import { LoginPage } from "./pages/login/login.jsx";
import { LoginWithAccessTokenPage } from "./pages/login/login_with_accesstoken.jsx";
import { PasswordForgetPage } from "./pages/login/password_forget.jsx";
import { PasswordResetPage } from "./pages/login/password_reset.jsx";
import { MaterialOverviewTabsPage } from "./pages/materiaal/materiaalOverviewTabs.jsx";
import { MaterialTabsPage } from "./pages/materiaal/materiaalTabs.jsx";
import { MeldingOverviewPage } from "./pages/materiaal/melding/meldingOverview.jsx";
import { MeldingPage } from "./pages/materiaal/melding/meldingPage.jsx";
import { NewsPage } from "./pages/news/NewsPage.jsx";
import { OnderhoudsUrenPagina } from "./pages/onderhoud/index.jsx";
import { MijnOnderhoudPagina } from "./pages/profile/mijnOnderhoudsUren.jsx";
import { MyAccountPage } from "./pages/profile/myAccount.jsx";
import { MyNewsPagina } from "./pages/profile/myNews.jsx";
import { MyDataPagina } from "./pages/profile/mydata.jsx";
import { MyInstructorBook } from "./pages/profile/myinstructorbook.jsx";
import { MyStartsPagina } from "./pages/profile/mystarts.jsx";
import { RegistratiePagina } from "./pages/registratie/registratie.jsx";
import { ReservationPage } from "./pages/reservation/reservation.jsx";
import { NotFound } from "./pages/utils/404_not_found.jsx";
import { NotAuthorised } from "./pages/utils/405_not_authorized.jsx";
import { MaintenancePage } from "./pages/utils/503_maintenance.jsx";
import { NotFound404 } from "./pages/utils/NotFound404.jsx";
import { VoucherRoutes } from "./pages/vouchers/Router.jsx";
import { persistActions } from "./redux/actions.js";

import AdminRoutesRender from "./pages/admin/RouterRender.jsx";
import { useClub } from "./components/club/ClubContext.jsx";

// Club public route are components like login which can only be accessible for club, not with WWW in front or naked
function redirectToWWWModal() {
  Modal.error({
    content: (
      <div>
        <p>{$t("Navigeer naar je eigen club zweef.app pagina")}</p>
        <p className="small" style={{ marginTop: 18 }}>
          {$t("Deze heeft een website url als")}: https://
          <span className="bold">{$t("club")}</span>.
          {window.isZweef() ? "zweef.app" : "gliding.app"}
        </p>
        <p className="small">
          {$t("Of druk op de Logo van je club op de homepagina")}.
        </p>
      </div>
    ),
  });
}

export const ClubPublicRoute = ({ component: Component, ...rest }) => (
  // console.log('here')
  <Route
    {...rest}
    render={(props) => {
      if (config.tenant === "www") {
        // redirectToWWWModal();
        // return <Redirect to="/" />;
        console.log('WWWW')
      }
      return <Component {...props} {...rest} />;
    }}
  />
);

const RedirectExternal = ({ to, ...rest }) => {
  window.location.replace(to);
  return (
      <p>Sorry, this is a legacy page, you should hard refresh this page</p>
    );
};

// Private route is connected to Redux and will redirect to login if not authenticated
const has_access = (profile, access_required) => {
  if (!access_required) return true;
  return access_required.some((a) => {
    if (profile[a]) return true;
  });
};

export const PrivateRouteComponent = ({
  component: Component,
  isAuthenticated,
  profile,
  access_required,
  title,
  requiresFlight = false,
  requiresFinance = false,
  ...rest
}) => {
  document.title = `${title ? title + " | " : ""}${
    window.isZweef() ? "Zweef.App" : "Gliding.App"
  }`;

  // Check view mode access
  const { canView } = useClub();
  if (!canView(rest.path)) {
    return <NotFound />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        /** TODO remove show a club selector? */
        // backup, should not occur
        if (config.tenant === "www")
          return <RedirectExternal to="https://www.gliding.app" />;

        // case for not authenticated, then we do not have an access token, so we redirect to login
        if (!isAuthenticated)
          return (
            <Redirect to={`/login?redirect=${window.location.pathname}`} />
          );

        // price plan
        if (requiresFlight && !clubHasFlight()) return <NotAuthorised />;

        if (requiresFinance && !clubHasFinance()) return <NotAuthorised />;

        // case if you are authenticated, but you do not have access to the page, show 403
        if (!has_access(profile, access_required)) return <NotAuthorised />;

        // return if authenticated and access
        return <Component {...props} title={title} {...rest} />;
      }}
    />
  );
};

export const PrivateRoute = connect(
  (state) => ({
    isAuthenticated: state.persist.isAuthenticated,
    profile: state.persist.profile,
  }),
  null,
  null,
  { pure: false }
)(PrivateRouteComponent);

// Force logout component, then redirect to login
const LogOutComponent = ({ logout, ...rest }) => (
  // force logout
  <Route
    {...rest}
    render={() => {
      logout();
      return <Redirect to="/login" />;
    }}
  />
);

const LogOut = connect(
  null,
  (dispatch) => ({ logout: (data) => dispatch(persistActions.logout(data)) }),
  null,
  { pure: false }
)(LogOutComponent);

export const Router = () => {


  // get dtoClub from clubContext
  const { selectedDTOClub } = useClub();
  const isDTOview = !!selectedDTOClub


  return (
    <BrowserRouter>
      <Switch>

        <RedirectExternal
          path="/privacy*"
          to="https://www.gliding.app/privacy"
        />
        <RedirectExternal
          path="/terms*"
          to="https://www.gliding.app/terms.html"
        />
        <RedirectExternal
          path="/agree*"
          to="https://www.gliding.app/terms.html"
        />
        <RedirectExternal
          path="/pricing*"
          to="https://www.gliding.app/pricing.html"
        />

        <LogOut path="/logout" component={LogOut} />
        <ClubPublicRoute
          path="/login"
          title={$t("Inloggen")}
          component={LoginPage}
        />
        <ClubPublicRoute path="/forgot" component={PasswordForgetPage} />
        <Route
          exact
          path="/password/:password_reset_code/"
          component={PasswordResetPage}
        />
        <Route
          exact
          path="/new_email/:email_code/"
          component={ActivateEmailPage}
        />
        <Route
          exact
          path="/login_complete"
          component={LoginWithAccessTokenPage}
        />

        <PrivateRoute
          path="/register/print/:id"
          component={PrintAanmeldLijstPagina}
          title={$t("Aanmeldlijst")}
        />
        <PrivateRoute
          path="/register/:id"
          component={AanmeldLijstPagina}
          title={$t("Aanmeldlijst")}
        />
        <PrivateRoute
          path="/register"
          component={DagOverzichtPagina}
          title={$t("Aanmeldlijst")}
          link_to="register"
        />
        <PrivateRoute
          path="/reservations/:id?"
          component={ReservationPage}
          title={$t("Reserveren")}
          requiresFlight={true}
          access_required={["make_reservering", "wijzig_reservering"]}
        />
        <PrivateRoute
          path="/start/:id/:uuid"
          component={StartAdministratiePagina}
          title={$t("Startadministratie")}
          access_required={["vliegt", "wijzig_start", "wijzig_vluchten"]}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/start/:id"
          component={StartAdministratiePagina}
          title={$t("Startadministratie")}
          access_required={["vliegt", "wijzig_start", "wijzig_vluchten"]}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/start"
          component={DagOverzichtPagina}
          title={$t("Startadministratie")}
          link_to="start"
          access_required={["vliegt", "wijzig_start", "wijzig_vluchten"]}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/total/:id"
          component={DagtotaalPagina}
          title={$t("Dagtotaal")}
          access_required={["vliegt", "wijzig_start", "wijzig_vluchten"]}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/tow/:id"
          component={SleepAdministratiePagina}
          title={$t("Sleepadministratie")}
          access_required={["wijzig_sleep"]}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/tow"
          component={DagOverzichtPagina}
          title={$t("Sleepadministratie")}
          link_to="tow"
          access_required={["wijzig_sleep"]}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/dailyreport/:id"
          component={DagVerslagPagina}
          title={$t("Dagverslag")}
          access_required={["ziet_dto"]}
        />
        <PrivateRoute
          path="/dailyreport"
          component={DagOverzichtPagina}
          title={$t("Dagverslagen")}
          link_to="dailyreport"
          access_required={["ziet_dto"]}
        />
        <PrivateRoute
          path="/rosters/:id"
          component={RoostersPagina}
          title={$t("Roosters")}
        />
        <PrivateRoute
          path="/rosters"
          component={RoostersPagina}
          title={$t("Roosters")}
        />
        <ClubPublicRoute
          path="/status/:afdeling/:materialID/:activeTab/:obj_id"
          component={MaterialTabsPage}
          title={$t("Status")}
          requiresFlight={true}
        />
        <ClubPublicRoute
          path="/status/:afdeling/:materialID/:activeTab"
          component={MaterialTabsPage}
          title={$t("Status")}
          requiresFlight={true}
        />
        <ClubPublicRoute
          path="/status/:afdeling/:materialID"
          component={MaterialTabsPage}
          title={$t("Status")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/overview"
          component={MaterialOverviewTabsPage}
          title={$t("Material")}
          activeTab="material"
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/workorders"
          component={MaterialOverviewTabsPage}
          title={$t("Workorders")}
          activeTab="workorders"
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/parts"
          component={MaterialOverviewTabsPage}
          title={$t("Parts")}
          activeTab="parts"
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/teams"
          component={MaterialOverviewTabsPage}
          title={$t("Teams")}
          activeTab="teams"
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/:materialID/:activeTab/:obj_id/:action"
          component={MaterialTabsPage}
          title={$t("Materiaal")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/:materialID/:activeTab/:obj_id"
          component={MaterialTabsPage}
          title={$t("Materiaal")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/:materialID/:activeTab"
          component={MaterialTabsPage}
          title={$t("Materiaal")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material/:materialID"
          component={MaterialTabsPage}
          title={$t("Materiaal")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/material"
          component={MaterialOverviewTabsPage}
          title={$t("Materiaal")}
          activeTab="material"
          requiresFlight={true}
        />
        <PrivateRoute
          path="/report/:id"
          component={MeldingPage}
          title={$t("Melding")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/report"
          component={MeldingOverviewPage}
          title={$t("Meldingen")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/findings/:id"
          component={FindingDetailPage}
          access_required={["wijzig_findings"]}
          title={$t("Bevindingen")}
        />
        <PrivateRoute
          path="/findings"
          component={FindingsPage}
          access_required={["wijzig_findings"]}
          title={$t("Bevindingen")}
        />
        <PrivateRoute
          path="/maintenancehours"
          component={OnderhoudsUrenPagina}
          access_required={["wijzig_winteruren", "goedkeuren_uren"]}
          title={$t("Onderhoudsuren")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/members/:id"
          title={$t("Ledenlijst")}
          component={LedenLijstOverzichtPagina}
        />
        <PrivateRoute
          path="/members"
          title={$t("Ledenlijst")}
          component={LedenLijstOverzichtPagina}
        />
        <PrivateRoute
          path="/dto/:id"
          component={DTOOverzicht}
          title={$t("DTO overzicht")}
          access_required={["ziet_dto"]}
        />
        <PrivateRoute
          path="/dto"
          component={DTOOverzicht}
          title={$t("DTO overzicht")}
          access_required={["ziet_dto"]}
        />
        <PrivateRoute
          path="/email"
          component={EmailPage}
          title={$t("Email")}
          access_required={["ziet_emaillijst"]}
        />
        <PrivateRoute
          path="/news"
          component={NewsPage}
          title={$t("News")}
          access_required={["wijzig_news"]}
        />
        <PrivateRoute
          path="/my_starts"
          component={MyStartsPagina}
          title={$t("Mijn starts")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/my_dto"
          component={MyInstructorBook}
          title={$t("Mijn instructieboek")}
        />


        <PrivateRoute
          path="/my_account"
          component={MyAccountPage}
          title={$t("Mijn betalingen")}
          requiresFinance={true}
        />
        
        <PrivateRoute
          path="/my_details"
          component={MyDataPagina}
          title={$t("Mijn gegevens")}
        />
        <PrivateRoute
          path="/my_maintenance"
          component={MijnOnderhoudPagina}
          title={$t("Mijn onderhoud")}
          requiresFlight={true}
        />
        <PrivateRoute
          path="/my_news"
          component={MyNewsPagina}
          title={$t("Mijn nieuws")}
        />
        <PrivateRoute
          path="/documents/:tabID"
          component={DocumentsPagina}
          title={$t("Documenten")}
        />
        <PrivateRoute
          path="/documents"
          component={DocumentsPagina}
          title={$t("Documenten")}
        />
        <PrivateRoute
          path="/d:uuid"
          component={DocumentShortcutPage}
          title={$t("Documenten")}
        />
        
        <PrivateRoute
          path="/"
          exact
          component={isDTOview ? LedenLijstOverzichtPagina : Dashboard}
          title={$t("Dashboard")}
          link_to="register"
        />

        <Route
          path="/maintenance"
          exact
          component={MaintenancePage}
          title="503"
        />
        <Route
          path="/registration"
          exact
          component={RegistratiePagina}
          title={$t("Club registreren")}
        />
        <PrivateRoute
          path="/unsubscribe"
          component={MyDataPagina}
          access_required={[]}
          title={$t("Mijn gegevens")}
        />
        <Route
          path="/admin"
          access_required={["ziet_staff"]}
          title={$t("Vluchten")}
        >
          <AdminRoutesRender>
            <Route component={NotFound404} title={$t("Niet gevonden")} />
          </AdminRoutesRender>
        </Route>

        <Route
          path="/voucher"
          access_required={["ziet_staff"]}
          title={$t("Bon")}
        >
          <VoucherRoutes>
            <Route component={NotFound404} title={$t("Niet gevonden")} />
          </VoucherRoutes>
        </Route>

        <Route
          path="/gift"
          access_required={["ziet_staff"]}
          title={$t("Cadeaubon")}
        >
          <VoucherRoutes>
            <Route component={NotFound404} title={$t("Niet gevonden")} />
          </VoucherRoutes>
        </Route>

        {/* Catch all 404 */}

        <Route
          path="/403"
          exact
          component={NotAuthorised}
          title={$t("Geen authorisatie")}
        />

        <Route component={NotFound} title={$t("Niet gevonden")} />
      </Switch>
    </BrowserRouter>
  );
};
